app.factory(
    'AdminService', ['LocalStorage', 'ApiService', '$rootScope', AdminService]
);

function AdminService(LocalStorage, ApiService, $rootScope) {

    var self = {}

    self.SaveAdminCityInfo = function (zone) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(zone);
        var request = ApiService.post("/api/adminApi/UpdateAdminZoneInfo", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        //.then(handleSuccess, handleError('Error getting all languages'));
        return request;        
    };

    self.UpdateAdminCityTeam = function (zoneTeam) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(zoneTeam);
        var request = ApiService.post("/api/adminApi/UpdateAdminZoneTeam", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        //.then(handleSuccess, handleError('Error getting all languages'));
        return request;
    };

    self.UpdateAdminUserInfo = function (user) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(user);
        var request = ApiService.post("/api/adminApi/UpdateAdminUserInfo", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };

    self.ResendEmailWelcome = function (user, emailTitle) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(user);
        var request = ApiService.post("/api/adminApi/ResendEmailWelcome?emailTitle="+emailTitle, st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };

    self.ResetFieldSize = function () {
        $rootScope.ShowIconLoading();
        var request = ApiService.get("/api/adminApi/ResetFieldSize")
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };
    
    self.UpdateFieldSize = function (fieldSizeObj) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(fieldSizeObj);
        var request = ApiService.post("/api/adminApi/UpdateFieldSize", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };

    self.UpdateStyleSheet = function (styleSheetList) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(styleSheetList);
        var request = ApiService.post("/api/adminApi/UpdateStyleSheet", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };

    self.CreateUser = function (userInfos, emailTitle) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(userInfos);
        var request = ApiService.post("/api/adminApi/CreateUser?emailTitle="+emailTitle, st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });      
        return request;
    };
    
    self.ExecuteAdminTool = function () {
        return ApiService.get("/api/adminApi/ReplaceRegexTextInDescriptionTranslation?key=manual");            
    };

    self.CreateZone = function (zoneInfos) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(zoneInfos);
        var request = ApiService.post("/api/adminApi/CreateZone", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
            },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };

    self.getAdminGeneralInfo = function () {
        return ApiService.get('/api/adminApi/getAdminGeneralInfo');
    }

    self.getAdminZoneInfo = function (id, lang) {
        return ApiService.get('/api/adminApi/getAdminZoneInfo?id=' + id + '&lang=' + lang);
    }        

    self.getAdminZoneTeam = function (id, lang) {
        return ApiService.get('/api/adminApi/GetAdminZoneTeam?id=' + id + '&lang=' + lang);
    }

    self.getAdminZoneTeamEmpty = function (id, lang) {
        return ApiService.get('/api/adminApi/getAdminZoneTeamEmpty?id=' + id + '&lang=' + lang);
    }

    self.getAdminUserInfo = function (id) {
        return ApiService.get('/api/adminApi/GetAdminUserInfo?id=' + id);
    }
        
    self.GetAdminUserInfoForCreation = function () {
        return ApiService.get('/api/adminApi/GetAdminUserInfoForCreation');
    }

    self.GetAdminZoneInfoForCreation = function (lang) {
        return ApiService.get('/api/adminApi/GetAdminZoneInfoForCreation?&lang=' + lang);
        }
    
    self.GetCityListByKeyword = function (zoneId, lang, keyword) {
        return ApiService.get('/api/adminApi/GetCityListByKeyword?z=' + zoneId + '&lang=' + lang + '&keyword=' + keyword);
    }
    
    self.DeleteUser = function (user) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(user);
        var request = ApiService.post("/api/adminApi/DeleteUser", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        //.then(handleSuccess, handleError('Error getting all languages'));
        return request;
    };

    self.DeleteZone = function (zone) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(zone);
        var request = ApiService.post("/api/adminApi/DeleteZone", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        //.then(handleSuccess, handleError('Error getting all languages'));
        return request;
    };

    // [Lam Hong 21-Jul-2025] LVCG-198: To complete the ZONE - RUBRICS (Sections) list page.
    self.UpdateAdminCityRubric = function (zone) {
        $rootScope.ShowIconLoading();
        var st = JSON.stringify(zone);
        var request = ApiService.post("/api/adminApi/UpdateAdminZoneRubric", st)
            .then(
                function success(data) {
                    $rootScope.ShowIconSuccess();
                },
                function error(data) {
                    $rootScope.ShowIconError();
                });
        return request;
    };

    function handleSuccess(res) {
        return res.data;
    }

    function handleError(error) {
        return function () {
            return { success: false, message: error };
        };
    }    

    return self;
}